﻿import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import classes from "../maintainers.module.scss";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import { agricolaName, dateToLocale } from "@/services/Utils";

import CustomTooltip from "@/components/desktop/tooltip/CustomTooltip";
import CustomBadge from "@/components/desktop/badge/CustomBadge";

const IncidentsTableBody = ({ handleDelete }) => {
	const { balances, version } = useSelector((state) => state.maintainers_balances);

	const navigate = useNavigate();

	return (
		<tbody>
			{balances &&
				balances.map((item, i) => {
					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{item.balance_id}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.small_text}`}>
									<CustomTooltip text={agricolaName(item.name_customer)} description={item.name_customer} />
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.small_text}`}>
									<CustomTooltip text={agricolaName(item.name)} description={item.name} />
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>{item.anydesk_id}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.small_text}`}>
									{item.estates &&
										item.estates
											.filter(
												(estate, index, self) => index === self.findIndex((t) => t.estate_parent_name === estate.estate_parent_name),
											)
											.map((estate_parent, i) => (
												<div key={i} style={{ margin: "1px" }}>
													<CustomBadge variant="info">{estate_parent.estate_parent_name.toUpperCase()}</CustomBadge>
												</div>
											))}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.small_text}`} style={{ flexWrap: "wrap" }}>
									{item.estates && item.estates.length > 0
										? item.estates.map((estate, i) => {
												return (
													<div key={i} style={{ margin: "1px" }}>
														<CustomBadge variant="neutral">{estate.label.toUpperCase()}</CustomBadge>
													</div>
												);
											})
										: ""}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>{dateToLocale(item.last_sync)}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} ${classes.small_text}`}>{item.name_status}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} ${classes.small_text}`}>
									{version.version === item.version ? (
										<CustomBadge variant="success">{item.version}</CustomBadge>
									) : (
										<CustomBadge variant="danger">{item.version ? item.version : "-"}</CustomBadge>
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									<PencilSvg className={classes.icon} onClick={() => navigate("/mantenedores/balanzas/editar/" + item.balance_id)} />
									<RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default IncidentsTableBody;
